import { type FC, Fragment, useState } from "react";
import Button from "../../Buttons/Button";
import RetractableInput from "../../Forms/RetractableInput";
import { type MediaPathType } from "./MediaUtilities";

interface Props {
    path: Array<MediaPathType>;
    onCancel: () => void;
    onNew: (name: string) => Promise<void>;
}

export const FolderCreateSmall: FC<Props> = ({
    path,
    onCancel,
    onNew,
}) => {
    const [ name, setName ] = useState("");

    return (
        <Fragment>
            <div className="new-folder-form">
                <RetractableInput
                    label="Current Path"
                    hasValue={true}
                >
                    {() => (
                        <div className="new-folder-path">
                            {path.map(dir => (
                                <div key={dir.id} className="path-item">
                                    <span className="separator">/</span>
                                    <span className="dir">
                                        {dir.name}
                                    </span>
                                </div>
                            ))}
                        </div>
                    )}
                </RetractableInput>
                <RetractableInput
                    label="New Folder"
                    hasValue={!!name}
                >
                    {(onFocus, onBlur) => (
                        <input
                            onBlur={onBlur}
                            onFocus={onFocus}
                            name="newName"
                            value={name}
                            onChange={e => {
                                setName(e.currentTarget.value);
                            }}
                        />
                    )}
                </RetractableInput>
            </div>
            <div className="new-folder-actions">
                <Button
                    onClick={onCancel}
                >
                    Cancel
                </Button>
                <Button
                    disabled={!name}
                    onClick={() => {
                        void onNew(name);
                    }}
                >
                    Create
                </Button>
            </div>
        </Fragment>
    );
};
